export default "__VITE_ASSET__DIFps1tt__"